module.exports = __webpack_public_path__ + "img/beginShowStep4-1.dd19e52d.png";